import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from './OrganizationAppResource';
import WildAppResource from './WildAppResource';

class ExternalOfficeAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'external-office';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'externals/offices';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'created_at',
      'updated_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'name',
      'organizationUuid',
      'externalId',
      'externalData',
      'connectorUuid',
      'externalName',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      connector:             WildAppResource,
      organization:             OrganizationAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return [
    ];
  }

}

export default ExternalOfficeAppResource;
